import React from "react";
import { useWizard } from "react-use-wizard";
import { useUserContext } from "../../../../contexts/User";
import { updateUser } from "../../../../utils/api/users";
import { StepContent } from "../Components";
import CircleCheck from "../../../../assets/CheckCircle.svg";
import CircleCross from "../../../../assets/XCircle.svg";
import { RectangleButton } from "../../../Actions";

const Rules: React.FC = () => {
  const { nextStep } = useWizard();
  const { user } = useUserContext();

  const funWords = ["Unicorn", "Sphinx", "Chimera", "Sasquatch", "Phoenix"];
  const funWord = funWords[Math.floor(Math.random() * funWords.length)];

  const handleClick = async (trusted: boolean) => {
    if (!user?.id) return;
    await updateUser({ id: user.id, trusted });
    nextStep();
  };
  return (
    <StepContent
      title={`You’ve been paired with Anonymous ${funWord}.`}
      description="Choose wisely.">
      <div className="flex gap-6 w-full">
        <RectangleButton
          analyticsProperty="trust"
          color="teal"
          onClick={() => handleClick(true)}>
          <CircleCheck width="40" className="text-coinage-teal" />
          <span>Trust</span>
        </RectangleButton>
        <RectangleButton
          analyticsProperty="distrust"
          color="orange"
          onClick={() => handleClick(false)}>
          <CircleCross width="40" className="text-coinage-orange" />
          <span>Distrust</span>
        </RectangleButton>
      </div>
    </StepContent>
  );
};

export default Rules;
